<script setup lang="ts">
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { handleNext } from '../tutorialSteps'

const playerFlagsStore = usePlayerFlagsStore()

const handleNextStep = async () => {
  await handleNext('tutorial_fog_of_war')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/exploration.webm"
  >
    <template #text>
      <p class="pb-2">
        Amazing!
      </p>
      <p class="pb-2">
        Just so you know, our scientists explained that what we see on the map depends on the scanners <GenericIcon type="scanner"/> installed on our ships and planets.
      </p>
    </template>

    <template #alerts>
      <Alert type="info">
        The map only shows you what your scanners <GenericIcon type="scanner"/> can see. Also known as a Fog-of-war system.
      </Alert>
    </template>

    <template #buttons>
      <ActionButton @click="handleNextStep">Understood</ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>